import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {Restaurant} from "../../shared/model/restaurant";
import { Ng2SmartTableModule, LocalDataSource } from 'ng2-smart-table';
import {LocalStripeService} from "../../shared/services/stripe/local.stripe.service";
import {CurrencyPipe, DatePipe} from "@angular/common";


/**
 * PRIVATE
 * Flatten a deep created_by into a one level created_by with it’s path as key
 * @param  {object} object - The created_by to be flattened
 *
 * @return {object}        - The resulting flat created_by
 */
const flatten = object => {
  return Object.assign( {}, ...function _flatten( objectBit, path = '' ) {  //spread the result into our return created_by
    return [].concat(                                                       //concat everything into one level
      ...Object.keys( objectBit ).map(                                      //iterate over created_by
        key => typeof objectBit[ key ] === 'object' ?             //check if there is a nested created_by
          _flatten( objectBit[ key ], `${ path }/${ key }` ) :        //call itself if there is
          ( { [ `${ path }/${ key }` ]: objectBit[ key ] } )                //append created_by with it’s path as key
      )
    )
  }( object ) );
};





@Component({
  selector: 'app-invoice-history',
  templateUrl: './invoice-history.component.html',
  styleUrls: ['./invoice-history.component.css']
})
export class InvoiceHistoryComponent implements OnInit {

   restaurant:Restaurant;

   data = [];
  private flatData = [];
  private variableCurrency = 'USD';
  private customerId;string;

  @Input()
  initialValues:any;

  constructor(
    private router:Router,
    private route: ActivatedRoute,
    private stripeservice: LocalStripeService,
    private datePipe: DatePipe,
    private currencyPipe:CurrencyPipe

  ) {

    this.source = new LocalDataSource(this.data);

    route.data
      .subscribe( ( data : {restaurant:Restaurant  }) =>
        {
          this.restaurant = data.restaurant;
        }

      )

  }

  ngOnInit() {


    this.stripeservice.getStripeCustomer(this.restaurant.$key).subscribe( billInfo => {
      this.customerId = billInfo.id;
      this.stripeservice.getInvoicesByKey(billInfo.id)
        .subscribe( invoices => {
          this.populateData(invoices);
          this.data = this.flatData;
        })

    });




  }

  populateData(dataP){
    for (let i in dataP){
        // console.log(dataP[i]);
      let flatObject = this.getInvoiceHeadddre(dataP[i]);
        // console.debug("flatObject");
        // console.log(flatObject);
      this.flatData.push(flatObject);
    }
    // console.debug("Flat Data !");
    // console.log(this.flatData)


  }

  private getInvoiceHeadddre(dataP2: any) {

    let id_parm = dataP2.$key;
    let $key = dataP2.$key.substr(4,8);
    let symb = dataP2.currency.toUpperCase();
    let amount_due =  this.formatCurrency(dataP2.amount_due,symb);
    let lines_0_period_start = this.formattDate(dataP2.lines[0].period.start);
    let lines_0_period_end = this.formattDate(dataP2.lines[0].period.end);

     return {
       "id_parm":id_parm,
       "$key":$key,
       "amount_due":amount_due,
       "lines_0_period_start":lines_0_period_start,
       "lines_0_period_end":lines_0_period_end
     };
  }

  formattDate(dt){
    // dateFormat(ret, "dddd, mmmm dS, yyyy, h:MM:ss TT");

    let ret = this.datePipe.transform(new Date(dt * 1000), 'yMMMd');
    // ret = {{ret | date: 'dd/MM/yyyy H:mm' }}
    return ret
  }

  formatCurrency(amt,symb){
    // console.log(symb);
    let symbStr = symb.toString();
    let ret = this.currencyPipe.transform(amt/100, symb, true)
    // TODO : URGENt Before Production Make currency Dynamic
    return ret
}

  sanitizeInvoiceObj(obj){
    let cleanReturn = {};
    let key_names = Object.keys(obj);
    let x =  0;
    let symb = '';
    for (let i in obj){
      if (key_names[x] == 'currency'){
        symb = obj[i].toUpperCase();
      }
      if (key_names[x] === 'date' || key_names[x] === 'lines_0_period_end' || key_names[x] === 'lines_0_period_start' || key_names[x] === 'lines_0_plan_created'){
          let clean_data = this.formattDate(obj[i]);
          cleanReturn[i]= clean_data;
      } else {
        if (key_names[x] === 'amount_due' || key_names[x] === 'lines_0_amount' || key_names[x] === 'lines_0_plan_amount'){
          let clean_data = this.formatCurrency(obj[i],symb);
          cleanReturn[i]= clean_data;
        } else {
          cleanReturn[i] = obj[i]
        }
;      }
      x = x + 1;
    }

    return cleanReturn;
  }

  flattenObject(ob) {
    let toReturn = {};

    for (let i in ob) {
      if (!ob.hasOwnProperty(i)) continue;

      if ((typeof ob[i]) == 'object') {
        let flatObject = ob[i];
        for (let x in flatObject) {
          if (!flatObject.hasOwnProperty(x)) continue;
            if(flatObject[x].constructor == Array){
              for (let y in flatObject[x]){
                if ((typeof flatObject[x][0]) == 'object') {
                  let flatObjectInt = this.flattenObject(flatObject[x][0]);
                  for (let z in flatObjectInt){
                    toReturn[i+'_'+y+'_'+z] = flatObjectInt[z]
                  }
                } else {
                  toReturn[i + '_' + y] = flatObject[x][0];
                }

              }

            } else {
              toReturn[i + '_' + x] = flatObject[x];
            }
        }
      } else {
        toReturn[i] = ob[i];
      }
    }
    return toReturn;
  };

  public onViewClick(event: any): any {




    let navigateRoute = './restaurants/'+ this.customerId


    navigateRoute = navigateRoute +'/invDetail/' + event.data.id_parm;


    this.router.navigate([navigateRoute]);

  }

  public cancel() {

    let restaurantId = this.restaurant.$key;

    let navigateRoute = './restaurants/'+ restaurantId

    navigateRoute = navigateRoute +'/edit';

    this.router.navigate([navigateRoute], {queryParams:{view:'Account'}});



  }

  getPreviousInvoices(){
    let d = new Date();
    let n = d.getTime();


  }

  settings = {

    actions: {
      custom: [
        {
          name: 'view',
          title: 'View '
        },
      ],
      add : false,
      edit: false,
      delete:false,
      columnTitle:''
    },

    columns: {
      $key: {
        title: 'ID',
        filter: false,
        },
      amount_due: {
        title: 'Amount',
        filter: false,
        },
      lines_0_period_start:{
        title: 'Period Start',
        filter: false,
        },
      lines_0_period_end:{
        title: 'Period End',
        filter:false,
        }
      }
  };

  source: LocalDataSource;

  onCustom(event) {
    alert(`Custom event '${event.action}' fired on row №: ${event.data.email}`)
  }



}



// WEBPACK FOOTER //
// ./src/app/invoice/invoice-history/invoice-history.component.ts